var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHoroscope = function SvgHoroscope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 3h18v18H3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94 5.918a2.213 2.213 0 1 1 4.425 0l.005 11.001M11.367 5.94c0-1.211.984-2.221 2.196-2.237a2.205 2.205 0 0 1 2.234 2.205c0 5.67.07 14.389 5.203 14.389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.852 9.808c0-1.212 1-2.222 2.21-2.238a2.205 2.205 0 0 1 2.235 2.205c0 3.643-2.589 8.272-7.861 10.57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M6.938 16.922V5.32a1.617 1.617 0 0 0-3.235 0v1.407"
  }))));
};
export default SvgHoroscope;